import '../App.css';
import { Helmet } from 'react-helmet-async';
import { Box, Container, Typography } from '@mui/material';
import textData from '../json/text.json';
import Header from '../components/menu/organisms/Header';
import Footer from '../components/footer/Footer';
import H1 from '../components/common/atoms/H1';
import LinkButton from '../components/top/atoms/LinkButton';

/**
 * 404ページ（存在しないURL・存在しない記事番号）
 * @returns
 */
function NotFound() {
  return (
    <div>
      <Helmet>
        <title>{`ページが見つかりません｜${textData['companyName']['ja']}`}</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <header>
        <Header />
      </header>

      <main className="main-content">
        <H1 text='ページが見つかりません' />
        <Container sx={{ py: { xs: 6, md: 10 }, textAlign: 'center' }}>
          <Typography sx={{ fontSize: { xs: 40, md: 64 }, fontWeight: 'bold', mb: 2 }}>404</Typography>
          <Typography sx={{ fontSize: { xs: 14, md: 16 }, lineHeight: 2, mb: 6 }}>
            お探しのページは移動または削除されたか、URLが間違っている可能性があります。<br />
            お手数ですが、トップページから目的のページをお探しください。
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, justifyContent: 'center' }}>
            <LinkButton title='トップページへ' linkTo='/' />
            <LinkButton title={textData['menu.contact']['ja']} linkTo='/contact' />
          </Box>
        </Container>
      </main>

      <footer>
        <Footer />
      </footer>
    </div>
  );
}

export default NotFound;
